import type { DefaultSearchParams } from "./common";

interface RequestGetInquiries extends DefaultSearchParams {
	scope: EScope;
}

interface Inquiry {
	id: number;
	title: string; // 제목
	writerName: string; // 작성자 이름
	categoryNameKo: string; // 카테고리 이름
	status: EStatus;
	hasAttachments: boolean; // 첨부파일 여부
	isSecret: boolean; // 비밀글 여부
	isMember: boolean; // 회원글 여부
	createdAt: string;
	answeredAt: string;
}

interface RequestGetDetailInquiry {
	id: number;
	data?: {
		password?: string;
	};
}

interface ResponseGetDetailInquiry {
	id: number;
	title: string;
	writerName: string;
	categoryNameKo: string;
	content: string;
	status: EStatus;
	createdAt: string;
	attachmentUrls: string[];
	isSecret: boolean;
	isMember: boolean;
	answerContent: string;
	answeredAt: string;
}

interface RequestSubmitInquiry {
	title: string;
	content: string;
	inquiryCategoryId: number; // 카테고리 아이디
	attachmentFileIds?: number[]; // 첨부파일 아이디
	guestName?: string; // 작성자 이름
	guestEmail?: string; // 작성자 이메일
	password?: string; // 비밀번호
}

enum EScope {
	ALL = "all",
	ME = "me",
}

enum EStatus {
	PENDING = "PENDING",
	ANSWERED = "ANSWERED",
}

export type {
	Inquiry,
	RequestGetInquiries,
	RequestGetDetailInquiry,
	ResponseGetDetailInquiry,
	RequestSubmitInquiry,
};

export { EScope, EStatus };
